import { Col, Row } from "react-bootstrap";
import Menu from "../components/Menu";
import { useState } from "react";
import Users from "./Home/Users";
import Navigation from "../containers/Navigation";
import useUXStore from "../api/ux/store";
import { PagesDefinition } from "../App";


const Home = () => {
    const [selected, setSelected] = useState(PagesDefinition[0].id)
    const { replacePage } = useUXStore( state => state)
    // callback when menu was selected
    const onMenuSelected = (_selected:string) => {
        if (_selected !== selected) {
            setSelected(_selected)
            // find page
            for (let index = 0; index < PagesDefinition.length; index++) {
                const page = PagesDefinition[index];
                if (page.id === _selected) {
                    replacePage(page.label, page.element)
                    break;
                }
                if (page.sub === null) continue;

                for (let index = 0; index < page.sub.length; index++) {
                    const subpage = page.sub[index];
                    if (subpage.id === _selected) {
                        replacePage(subpage.label, subpage.element)
                        break
                    }
                }
            }
        }
    }
    return (
        <Row className="home-layout">
            <Col xs={4} className="menu-column">
                <h4>Mobile Manager</h4>
                <Menu selected={selected} onSelected={onMenuSelected}/>
            </Col>
            <Col className="content-column">
                <Navigation initialPage={{
                    Label:"Users", 
                    Element:<Users />}}/>
            </Col>
        </Row>
        
    )
}

export default Home;
